import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p384243560042590208',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
